// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();
	site.nav.init();
	site.responsive.tables();
	site.responsive.videos();
	site.divisionPicker.init();
	site.tables.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
});

document.getElementsByTagName('body')[0].onscroll = () => {
	if (window.scrollY > 0) {
		if (!document.body.classList.contains('stickyHeader')) {
			document.body.classList.add('stickyHeader');
		}
	} else {
		if (document.body.classList.contains('stickyHeader')) {
			document.body.classList.remove('stickyHeader');
		}
	}
};
